import {
  Autocomplete,
  Button,
  CircularProgress,
  Divider,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { LabDataType, LabItemType, LabTemplateType } from "../type";
import { ContextType, LabContext } from "./index";
import { getLabTemplates } from "../services";
import { useQuery, useQueryClient } from "react-query";
import LabTemplateEdit from "./LabTemplateEdit";
import { clinicId } from "../../../constants";
import { useParams } from "react-router-dom";
import SaveSpecimendate, { dateFormat } from "./SaveSpecimendate";
import useSaveLabResult from "../hook/useSaveLabResult";
import DoneIcon from "@mui/icons-material/Done";
import dayjs from "dayjs";
import UploadedFileList from "./UploadedFileList";
import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
const LabResult = () => {
  const { encounterId } = useParams();
  const {showSnackbar} = usePopup()
  const {user} = useAuthentication()
  const { resultView, setResultView, setLabData, labData,setCheckAbnormalFlag,checkAbnormalFlag,isResultSaved,setEditData } = useContext(
    LabContext
  ) as ContextType;

  const { data: templates, isLoading: templatesLoading } = useQuery(
    ["getLabTemplates", resultView],
    async () => await getLabTemplates(resultView as LabItemType),
    {
      refetchOnWindowFocus: false,
    }
  );
  const queryClient = useQueryClient();
  const successFunction = () => {
    queryClient.invalidateQueries(["getLabResult"]);
    setResultView(null)
  };
  const { mutate: save, isLoading: saveLabLoading } = useSaveLabResult(successFunction);

  const handleTemplateChange = (_: any, value: any) => {
    const arra: LabDataType[] = [];
    let checkData = {}
    let obj: LabDataType;
    (value as LabTemplateType).fields.forEach((item,index) => {
      console.log("time", dayjs(
        labData.specimenReceivedDateTime || dayjs().format(dateFormat),
        dateFormat
      ).format("DD/MM/YYYY"))
      obj = {
        _userId: 0,
        name: item?.fieldName,
        unit: item?.fieldUnit,
        range: item?.fieldRange,
        value: String(item?.fieldValue || 0),
        abnormalFlagId: 0,
        abnormalFlagName: "",
        clinicId,
        createdById: Number(user?.userId),
        labResultId: null,
        encounterId: Number(encounterId),
        labRequestId: resultView?.labId as number,
        templateId: value?.templateId,
        specimenReceivedDateTime: dayjs(
          labData.specimenReceivedDateTime || dayjs().format(dateFormat),
          dateFormat
        ).format(dateFormat) ,
        ip: "",
        type: "Result",
        valueType: dayjs(
          labData.specimenReceivedDateTime || dayjs().format(dateFormat),
          dateFormat
        ).format("DD/MM/YYYY"),
        obsLabId: item?.obsLabId,
      };
      arra.push(obj);
      if(!Boolean(obj.abnormalFlagId)){
        checkData = {...checkData,[`${index}`]:true}
      }
    });
    setCheckAbnormalFlag(checkData)
    setEditData({})
    setLabData((prev) => ({
      ...prev,
      data: arra,
    }));
  };

  const handleSaveData = () => {
    if(labData.data.length){
      if(Boolean(Object.entries(checkAbnormalFlag)?.length)){
        showSnackbar({
          message:"Please enter Abnormal flags !",
          open:true,
          variant:"warning",
          duration:4000
        })
      }else{
        save(labData.data);
        // setResultView(null)
        console.log("trigger save !")
      }
    }else{
      showSnackbar({
        message:"Make sure you've entered all required data before hitting save.",
        open:true,
        variant:"warning",
        duration:4000
      })
    }
  
  };

  const handleClose = ()=>{
    setResultView(null);
    setCheckAbnormalFlag({})
  }

  return (
    <div className="p-2">
      <Paper>
        <div className="grid grid-cols-12">
          <div className="col-span-5 flex justify-start items-center ml-3">
            <Typography sx={{ fontWeight: "semi-bold" }}>
              Lab Result of{" "}
              <span className="font-extrabold">{resultView?.name || ""}</span>
            </Typography>
          </div>

          <div className="flex gap-2 col-span-7 justify-end items-center gap-x-2 p-2">
            {!isResultSaved && <Autocomplete
            disableClearable
              fullWidth
              options={templates?.response || []}
              loading={templatesLoading}
              renderInput={(params) => (
                <TextField {...params} label="Select template" />
              )}
              getOptionLabel={(option) => option.templateName}
              isOptionEqualToValue={(option, value) =>
                option.templateId === value.templateId
              }
              onChange={handleTemplateChange}
            />}
            <SaveSpecimendate />
            <div className=" flex ">
              <UploadedFileList />
            </div>
            <div className="flex gap-x-5 me-3 justify-center items-center">
              <Button
                disabled={saveLabLoading || isResultSaved}
                sx={(theme) => ({ background: theme.palette.primary.main })}
                onClick={handleSaveData}
                endIcon={
                  saveLabLoading ? (
                    <CircularProgress size={20} />
                  ) : isResultSaved ? (
                    <DoneIcon />
                  ) : null
                }
              >
                {isResultSaved ? "saved" : "save"}
              </Button>
              <Button
                onClick={handleClose}
                sx={(theme) => ({
                  background: theme.palette.error.dark,
                  "&:hover": {
                    background: theme.palette.error.main,
                  },
                })}
              >
                close
              </Button>
            </div>
          </div>
        </div>
        <Divider />
        <LabTemplateEdit />
      </Paper>
    </div>
  );
};

export default LabResult;

export const headings = [
  "Sl No",
  "Field name",
  "Value",
  "Unit",
  "Range",
  "Abnormal flag",
  "Actions",
];
